import { is_gen_2, isBluRC, isBluRotaryKnob, real_id } from 'src/helpers/interface_helpers';
import { devices } from '../lists/devices';
import { devices_status } from '../device-runtime/status';
import type { MultipleEvents } from 'src/types/MultipleEvents';
import { derived } from 'svelte/store';

export const inputStates = derived([devices, devices_status], ([$devices, $devices_status]) => {
	let events = JSON.parse(sessionStorage.getItem('lastInputsStates')) || {};
	let multipleEvents: MultipleEvents = {};
	for (let id in $devices) {
		const device = $devices[id];

		if (
			device.category === 'inputs_reader' ||
			(device.category === 'module' && device.mode === 'inputs_reader') ||
			device.category === 'remote_control'
		) {
			let event = '';
			let reporter;
			const status = $devices_status[real_id(id)];

			let time = +(new Date().getTime() / 1000).toFixed(0);

			if (typeof status?.inputs !== 'undefined') {
				event =
					status.inputs?.[device.channel]?.event !== ''
						? status.inputs?.[device.channel].event
						: event;
			} else if (is_gen_2(device)) {
				if (status?.['v_eve:' + device.channel]?.ev !== '') {
					event = status?.['v_eve:' + device.channel]?.ev;
				} else {
					event = status?.['v_eve:' + device.channel]?.last_ev;
					time = status?.['v_eve:' + device.channel]?.last_ev_ts / 1000;
				}
			} else if (device.gen == 'GBLE') {
				reporter = status?.reporter?.id !== '' ? status?.reporter : undefined;

				if (status?.['v_eve:' + device.channel]?.ev !== '') {
					event = status?.['v_eve:' + device.channel]?.ev;
				} else {
					event = status?.['v_eve:' + device.channel]?.last_ev;

					if (isBluRC(device.type) || isBluRotaryKnob(device.type)) {
						if (!multipleEvents[device.id]) {
							multipleEvents[device.id] = [];
						}
						Object.keys(status).forEach((key) => {
							// Handle button events (v_eve:) and scroll events (rotinput:)
							if (key.startsWith('v_eve:')) {
								const channel = key.split(':')[1];
								multipleEvents[device.id].push({
									id: channel,
									ev: status[key].ev,
									last_ev: status[key].last_ev,
									last_ev_ts: status[key].last_ev_ts,
								});
							} else if (key.startsWith('rotinput:')) {
								// Add scroll wheel events
								const channel = key.split(':')[1];
								multipleEvents[device.id].push({
									id: channel,
									ev: status[key].ev || '',
									last_ev: status[key].last_ev || '',
									last_ev_ts: status[key].last_ev_ts || 0,
									steps: status[key].steps || 0,
								});
							}
						});
						multipleEvents[device.id] = multipleEvents[device.id].sort(
							(a, b) => Number(a.id) - Number(b.id),
						);
					}
					time = status?.['v_eve:' + device.channel]?.last_ev_ts / 1000;
				}
			}

			if (typeof event !== 'undefined' && event !== '') {
				events = { ...events, [id]: { event, time, reporter } };
			}
			if (typeof multipleEvents[id] !== 'undefined' && multipleEvents[id].length > 0) {
				events = { ...events, [id]: multipleEvents[id] };
			}
		}
	}
	return events;
});

inputStates.subscribe((val) => sessionStorage.setItem('lastInputsStates', JSON.stringify(val)));
